  import React, { Component } from 'react';
  import * as yup from 'yup'
  import service from '../../core/service';

  import { toast } from 'react-toastify';
  interface IProps {
    userData?:any;
  }
  interface IState {
    price: number;
    loading: boolean;
    error: any;
    shareHolder:any;
  }
  export class PrePaymentController extends Component<IProps, IState> {
    datePickerRef: any;
    constructor(props: any) {
      super(props);
      this.datePickerRef = React.createRef();
    }
    state: IState = {
      price: 0,
      shareHolder: null,
      loading: false,
      error: []
    };

  

 
  }
  export default PrePaymentController;